/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { defineCustomElement } from '@tylertech/forge-core';
import { SkeletonComponent } from './skeleton';
export * from './skeleton-constants';
export * from './skeleton';
export function defineSkeletonComponent() {
    defineCustomElement(SkeletonComponent);
}
